import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import { Navigation, FreeMode, Pagination, Autoplay } from "swiper/modules";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import offerBanner from "../images/offerbanner.webp";
import poojaImg from "../images/Poojadinnerboard.webp";
import noimage2 from "../images/noimage.jpg";
import collectionBanner1 from "../images/home-banners/collection-1.webp";
import collectionBanner2 from "../images/home-banners/collection-2.webp";
import collectionBanner3 from "../images/home-banners/collection-3.webp";
import collectionBanner4 from "../images/home-banners/collection-4.webp";
import collectionBanner5 from "../images/home-banners/collection-5.webp";
import collectionBanner6 from "../images/home-banners/collection-6.webp";

import api from "../api/axios";
import CustomerReview from "../components/CustomerReview";

import "swiper/css";
import "swiper/css/pagination";

const collectionBannerSets = [
  [
    {
      type: "image",
      src: collectionBanner1,
    },
    {
      type: "image",
      src: collectionBanner2,
    },
  ],

  [
    {
      type: "image",
      src: collectionBanner3,
    },
    {
      type: "image",
      src: collectionBanner4,
    },
  ],

  [
    {
      type: "image",
      src: collectionBanner5,
    },
    {
      type: "image",
      src: collectionBanner6,
    },
  ],
];

const Home = () => {
  const navigate = useNavigate();

  const [homeCollections, setHomeCollections] = useState([]);
  const [loadingCollections, setLoadingCollections] = useState(true);
  const [activeCollectionId, setActiveCollectionId] = useState(null);

  const collectionRefs = useRef({});
  const swiperRef = useRef(null);

  const slides = [
    {
      type: "image",
      src: `${process.env.PUBLIC_URL}/home-banners/hero-1.webp`,
      mobileSrc: `${process.env.PUBLIC_URL}/home-banners/hero-1-mobile.webp`,
    },
    // {
    //   type: "video",
    //   src: "https://muffins.blr1.cdn.digitaloceanspaces.com/logoassets/backgroundvideo.mp4",
    // },
    {
      type: "image",
      src: `${process.env.PUBLIC_URL}/home-banners/hero-2.webp`,
      mobileSrc: `${process.env.PUBLIC_URL}/home-banners/hero-2-mobile.webp`,
    },
    {
      type: "image",
      src: `${process.env.PUBLIC_URL}/home-banners/hero-3.webp`,
      mobileSrc: `${process.env.PUBLIC_URL}/home-banners/hero-3-mobile.webp`,
    },
    
    {
      type: "image",
      src: `${process.env.PUBLIC_URL}/home-banners/hero-4.webp`,
      mobileSrc: `${process.env.PUBLIC_URL}/home-banners/hero-4-mobile.webp`,
    },
    {
      type: "image",
      src: `${process.env.PUBLIC_URL}/home-banners/hero-5.webp`,
      mobileSrc: `${process.env.PUBLIC_URL}/home-banners/hero-5-mobile.webp`,
    },
  ];







  const fetchHomeCollections = async () => {
    try {
      setLoadingCollections(true);

      const res = await api.get("/products_customer/home-collections");
      const collections = res.data?.data || [];

      setHomeCollections(collections);

      if (collections.length) {
        setActiveCollectionId(collections[0].collection_id);
      }
    } catch (error) {
      console.error("Home collections fetch failed:", error);
      setHomeCollections([]);
    } finally {
      setLoadingCollections(false);
    }
  };

  useEffect(() => {
    fetchHomeCollections();
  }, []);

  const getPrimaryImage = (product) => {
    const images = (product.media || []).filter(
      (item) => !item.media_type || item.media_type === "image"
    );

    return (
      images.find((image) => image.is_primary)?.image_url ||
      images[0]?.image_url ||
      noimage2
    );
  };

  const getProductName = (product) => {
    return product.product_name || product.name || "Product";
  };

  const goToCollection = (collectionId) => {
    navigate(`/shop?collection_id=${collectionId}`);
  };

  const scrollToCollection = (collectionId) => {
    setActiveCollectionId(collectionId);

    const section = collectionRefs.current[collectionId];

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };


  const getCollectionBannerSlides = (collectionIndex) => {
    if (!collectionBannerSets.length) {
      return [];
    }

    /*
     * Only collections at indexes 0, 3, 6, 9... use the
     * image-swiper layout.
     *
     * Convert:
     * 0  -> banner set 0
     * 3  -> banner set 1
     * 6  -> banner set 2
     * 9  -> banner set 0 again
     */
    const swiperCollectionPosition = Math.floor(collectionIndex / 3);

    const bannerSetIndex =
      swiperCollectionPosition % collectionBannerSets.length;

    return collectionBannerSets[bannerSetIndex];
  };

  return (
    <>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        navigation
        modules={[Navigation, Autoplay]}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={1500}
        className="mySwiper banner-swiper"
        onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
        onMouseLeave={() => swiperRef.current?.autoplay?.start()}
        onTouchStart={() => swiperRef.current?.autoplay?.stop()}
        onTouchEnd={() => swiperRef.current?.autoplay?.start()}
      >
        {slides.map((item, index) => (
          <SwiperSlide key={`${item.type}-${item.src}-${index}`}>
            {item.type === "image" ? (
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet={item.mobileSrc}
                />
                <img
                  src={item.src}
                  alt={`Wedding stationery banner ${index + 1}`}
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchPriority={index === 0 ? "high" : "auto"}
                  decoding={index === 0 ? "sync" : "async"}
                  width="1920"
                  height="681"
                />
              </picture>
            ) : (
              <video
                src={item.src}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      <section className="py-lg-5 py-3 mb-lg-5">
        <Container
          className="offer-banner"
          style={{ backgroundImage: `url(${offerBanner})` }}
        >
          <Row className="align-items-center justify-content-between">
            <Col lg={8} md={10} className="text-content">
              <div className="offer-text">
                <p>Exclusive Wedding Offer</p>
                <h3>
                  Flat 20% Off <span>on Premium Invitations</span>
                </h3>
              </div>

              <Link to="/shop" className="offer-btn">
                Explore
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {!loadingCollections && homeCollections.length > 0 && (
        <section className="collection-tabs-section deferred-section">
          <Container className="p-lg-0">
            <Row>
              <Col lg={12}>
                <div className="collection-home-tabs">
                  {homeCollections.map((collection) => (
                    <button
                      type="button"
                      key={collection.collection_id}
                      className={`collection-home-tab ${activeCollectionId === collection.collection_id
                        ? "active"
                        : ""
                        }`}
                      onClick={() =>
                        scrollToCollection(collection.collection_id)
                      }
                    >
                      {collection.name}
                    </button>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      {loadingCollections && (
        <section className="py-lg-5 py-3">
          <Container className="p-lg-0">
            <Row>
              <Col lg={12}>
                <h1 className="ptitle">SHOP BY COLLECTION</h1>
                <p>Loading collections...</p>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      {!loadingCollections &&
        homeCollections.map((collection, index) => {
          const collectionSlides =
            index % 3 === 0
              ? getCollectionBannerSlides(index)
              : [];

          return (
            <section
              className="py-lg-5 py-3 deferred-section"
              key={collection.collection_id}
              ref={(element) => {
                collectionRefs.current[collection.collection_id] = element;
              }}
            >
              <Container className="p-lg-0">
                <Row>
                  <Col
                    lg={12}
                    className="mb-4 d-flex justify-content-between align-items-center"
                  >
                    <h1 className="ptitle">{collection.name}</h1>

                    <Link
                      to={`/shop?collection_id=${collection.collection_id}`}
                      className="offer-btn bg-light text-dark"
                    >
                      View All
                    </Link>
                  </Col>

                  <Col lg={12} className="listcollection">
                    {index % 3 === 0 ? (
                      <div className="parent">
                        <div
                          className="imagediv"
                          onClick={() =>
                            goToCollection(collection.collection_id)
                          }
                          style={{
                            cursor: "pointer",
                            overflow: "hidden",
                          }}
                        >
                          {collectionSlides.length > 0 && (
                            <Swiper
                              modules={[Autoplay, Pagination]}
                              autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                              }}
                              pagination={{ clickable: true }}
                              loop={collectionSlides.length > 1}
                              speed={1000}
                            >
                              {collectionSlides.map(
                                (item, slideIndex) => (
                                  <SwiperSlide
                                    key={`${collection.collection_id}-${slideIndex}`}
                                  >
                                    <div
                                      style={{
                                        height: "534px",
                                        borderRadius: "6px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {item.type === "video" ? (
                                        <video
                                          src={item.src}
                                          autoPlay
                                          muted
                                          loop
                                          playsInline
                                          preload="metadata"
                                          className="w-100"
                                          style={{
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={item.src}
                                          alt={`${collection.name} banner`}
                                          loading="lazy"
                                          decoding="async"
                                          className="w-100"
                                          style={{
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                    </div>
                                  </SwiperSlide>
                                )
                              )}
                            </Swiper>
                          )}
                        </div>

                        {(collection.products || [])
                          .slice(0, 6)
                          .map((product, productIndex) => (
                            <div
                              className={`div${productIndex + 2
                                } sectioncatagories`}
                              key={product.product_id}
                              onClick={() =>
                                navigate(
                                  `/shop-details/${product.product_id}`
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={getPrimaryImage(product)}
                                alt={getProductName(product)}
                                loading="lazy"
                                decoding="async"
                              />

                              <h5>{getProductName(product)}</h5>
                            </div>
                          ))}
                      </div>
                    ) : index % 3 === 1 ? (
                      <ul>
                        {(collection.products || [])
                          .slice(0, 5)
                          .map((product) => (
                            <li key={product.product_id}>
                              <Link
                                to={`/shop-details/${product.product_id}`}
                              >
                                <div className="category-card">
                                  <div className="img">
                                    <img
                                      src={getPrimaryImage(product)}
                                      alt={getProductName(product)}
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </div>

                                  <div className="overlay">
                                    <h3>{getProductName(product)}</h3>
                                  </div>
                                </div>
                              </Link>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <Swiper
                        slidesPerView={4}
                        spaceBetween={15}
                        freeMode
                        navigation
                        pagination={{ clickable: true }}
                        modules={[
                          Navigation,
                          Pagination,
                          FreeMode,
                        ]}
                        className="mySwiper signaturebords"
                        breakpoints={{
                          320: { slidesPerView: 1 },
                          576: { slidesPerView: 2 },
                          768: { slidesPerView: 3 },
                          992: { slidesPerView: 4 },
                        }}
                      >
                        {(collection.products || []).map((product) => (
                          <SwiperSlide key={product.product_id}>
                            <div
                              className="sectioncatagories"
                              onClick={() =>
                                navigate(
                                  `/shop-details/${product.product_id}`
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={getPrimaryImage(product)}
                                alt={getProductName(product)}
                                loading="lazy"
                                decoding="async"
                              />

                              <h5>{getProductName(product)}</h5>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </Col>
                </Row>
              </Container>
            </section>
          );
        })}

      {!loadingCollections && homeCollections.length === 0 && (
        <section className="py-lg-5 py-3">
          <Container className="p-lg-0">
            <Row>
              <Col lg={12} className="mb-4">
                <h1 className="ptitle">SHOP BY COLLECTION</h1>
              </Col>

              <Col lg={12} className="listcollection">
                <div className="parent">
                  <div className="imagediv">
                    <img
                      src={poojaImg}
                      alt="Pooja Dinner Board"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>

                  <div className="div2 sectioncatagories">
                    <img
                      src={noimage2}
                      alt="No product available"
                      loading="lazy"
                      decoding="async"
                    />
                    <h5>No collections found</h5>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      <section className="review-section deferred-section">
        <CustomerReview />
      </section>

      {/* <section className="insta-section wedding-section">
        <Instagrampost />
      </section> */}
    </>
  );
};

export default Home;
